<template>
    <div id="wrapper">
        <Top></Top>
        <section id="inner-headline">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <h2 class="pageTitle">ニュース・お知らせ</h2>
                    </div>
                </div>
            </div>
        </section>
        <section id="content">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div><h2>ニュース・お知らせ一覧</h2></div>
                        <hr>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <section class="content-block section-wrapper gallery-1">
                            <div class="container">
                                <div class="row">
                                    <table>
                                        <tr>
                                            <td style="width:20%"><span>2019/4/26　</span></td>
                                            <td><span class="span-news">ニュース</span></td>
                                            <td><a href="#">株式会社アサテクス (Asatex) 設立</a></td>
                                        </tr>
                                    </table>
                                </div>
                            <!-- /.row --> 
                            <!-- /.container -->
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </section>
        <a href="#" class="scrollup"><i class="fa fa-angle-up active"></i></a>
        <Footer></Footer>
    </div>
</template>

<script>
import Top from "@/components/TopMenu.vue"
import Footer from "@/components/Footer.vue"
export default{
    name: 'Home',
    components: {
        Top,
        Footer
    }
}
</script>
<!-- <script src="../assets/js/jquery.js"></script>
<script src="../assets/js/jquery.easing.1.3.js"></script>
<script src="../assets/js/bootstrap.min.js"></script>
<script src="../assets/js/jquery.fancybox.pack.js"></script>
<script src="../assets/js/jquery.fancybox-media.js"></script>
<script src="../assets/js/portfolio/jquery.quicksand.js"></script>
<script src="../assets/js/portfolio/setting.js"></script>
<script src="../assets/js/jquery.flexslider.js"></script>
<script src="../assets/js/animate.js"></script>
<script src="../assets/js/custom.js"></script>
<script src="../assets/js/owl-carousel/owl.carousel.js"></script>
<script src="../assets/js/easypiechart/easypiechart.min.js"></script>
<script src="../assets/js/nivo-lightbox.js"></script>
<script src="../assets/js/main.js"></script> -->
<!-- <script>
    $(document).ready(function(){
        $(".headerpage").load("header.html");
        $(".footerpage").load("footer.html");
    });
</script> -->
<!--
<script>
    // You can also use "$(window).load(function() {"
    $(function () {
      // Slideshow 4
      $("#slider4").responsiveSlides({
        auto: true,
        pager:true,
        nav:true,
        speed: 500,
        namespace: "callbacks",
        before: function () {
          $('.events').append("<li>before event fired.</li>");
        },
        after: function () {
          $('.events').append("<li>after event fired.</li>");
        }
      });

    });
 </script> -->
<!--banner Slider starts Here-->

<style scoped>
</style>